import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Component as VueComponent, computed } from "vue";
import { useTrackEvent } from "shared/composables/tracking";
import { DashboardGridSize } from "@/types/Dashboard";
import { Report, ReportPlotType } from "@/types/Report";
import CycleTimesPlot from "@/views/reports/plots/cycle_times/CycleTimesPlot.vue";
import MilestonePlot from "@/views/reports/plots/milestone/MilestonePlot.vue";
import QueryValuePlot from "@/views/reports/plots/query_value/QueryValuePlot.vue";
import UnitValuesPlot from "@/views/reports/plots/unit_values/UnitValuesPlot.vue";
import WorkingHourCurvePlot from "@/views/reports/plots/working_hour_curve/WorkingHourCurvePlot.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportPlot',
  props: {
    report: {},
    title: {},
    hidePopover: { type: Boolean },
    width: {},
    height: {},
    hideLegend: { type: Boolean },
    spacingX: {},
    spacingY: {},
    isOnTheDashboard: { type: Boolean },
    dashboardGridSize: {}
  },
  emits: ["updateUseWhiteIcons", "widgetRouteClicked"],
  setup(__props: any, { emit: __emit }) {

const widgets: Record<ReportPlotType, VueComponent> = {
  cycle_times: CycleTimesPlot,
  working_hour_curve: WorkingHourCurvePlot,
  unit_values: UnitValuesPlot,
  milestone: MilestonePlot,
  query_value: QueryValuePlot,
};

const props = __props;

const emit = __emit;

const trackEvent = useTrackEvent();
const propsToBind = computed(() => {
  const { report, ...rest } = props;
  return rest;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(widgets[_ctx.report.type]), _mergeProps(propsToBind.value, {
    reportId: _ctx.report._id,
    filters: _ctx.report.filters,
    config: _ctx.report.config,
    aggregation: _ctx.report.aggregation,
    title: _ctx.report.name,
    onUpdateUseWhiteIcons: _cache[0] || (_cache[0] = ($event: any) => (emit('updateUseWhiteIcons', $event))),
    onWidgetRouteClicked: _cache[1] || (_cache[1] = ($event: any) => (emit('widgetRouteClicked'))),
    onReportInfoClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(trackEvent)('reports_info_click', { type: _ctx.report.type })))
  }), null, 16, ["reportId", "filters", "config", "aggregation", "title"]))
}
}

})